module.exports = {
  page: {
    title: 'OpenBasement',
    subtitle: 'anti-social no-network',
    footer: '¬©2016 OpenBasement team and (imagined) friends',
    about: 'About us'
  },

  events: {
    title: 'Events',
    empty: 'no events',

    stillAlive: 'On %{date} you were still alive'
  },

  interactions: {
    title: 'Interactions',
    empty: 'no interactions',

    'last-meeting': 'Last meeting: %{time}',
    'meetings-total': 'Total meetings: %{total}'
  },

  notifications: {
    title: 'Notifications',
    empty: 'no new notifications',

    '1th-entry': 'Congrats! First entry!',
    '2th-entry': 'And another one!',
    '5th-entry': 'I see that you get it',
    '10th-entry': 'You like spamming, don\'t you?',
    '20th-entry': 'Lot of messages',
    '50th-entry': 'So many messages to yourself - you are sooo lonely',
    '100th-entry': '100 messages that no one will ever read',
    '200th-entry': '200 messages to nobody - would you consider a bottle?',
    '500th-entry': '500 posts. You have some serious issues there',
    '1000th-entry': 'Ok, I shut up. It apparently turns you on.',

    'moody-day': 'Today you are quite moody, aren\'t you?'
  },

  journal: {
    meeting: 'meeting',
    mood: 'mood',
    note: 'note',
    hint: 'You can use'
  },

  profile: {
    menu: 'Profile',
    title: 'Your profile',
    content: 'Nobody cares about it.'
  },

  friends: {
    menu: 'Friends',
    title: 'Your friends',
    content: 'You don\'t have any, you live in a basement, remember?.'
  },

  settings: {
    menu: 'Settings',
    title: 'Your settings',
    content: 'We don\'t care enough to provide any reasonable settings.',

    locale: {
      en: 'English',
      pl: 'Polski'
    }
  },

  welcome: {
    title: 'Welcome to your Basement!',
    'content-1':
      'We know you don\'t have friends and you suffer each time you look at your FB wall filled with some shit.',
    'content-2':
      'We also know that you don\'t always want to spam everyone with whatever you think, you judgemental bastard.',
    'content-3':
      'But cry no more. Because we created this very special virtual Basement.',
    'content-4':
      'It provides you:',
    'content-5':
      'no registration - you don\'t have to waste your time registering anywhere! That is because...',
    'content-6':
      'there are no server calls - everything you do, happens in your browser and is stored locally! That means...',
    'content-7':
      'no spying or advertising - any sick thing you write will stay private.',
    'content-8':
      'markdown and emojione - so you could write pretty posts that no one else will ever see!',
    'content-9':
      'And finally, side bar - which will laugh at you. Because it can.'
  }
};



/** WEBPACK FOOTER **
 ** ./src/i18n/locales/en.js
 **/